export default {
  //系统基础
  EVENT_CLOSE_PAGE:'ClosePage', //关闭页面
  EVENT_REFRESH_USER_LIST:'RefreshUserList',//刷新用户列表

  //业务部分
  EVENT_REFRESH_SYS_USER_LIST:'RefreshSysUserList',//刷新用户列表

}



// WEBPACK FOOTER //
// ./src/constant/EventType.js